import { Injectable } from '@angular/core';
import { DataCoreService, DlistDto, GetDlist_Request, GetDlist_Response} from '@dabnet-kamu/libs/ui';
import { BehaviorSubject, catchError, finalize, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@dabnet-kamu/libs/ui';

@Injectable()
export class VgasBirimDosyaBelgeService {
  public birimKod!: number;
  public dosyaPlanKod!: string;
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
    public gridControlsList$ = this._gridControlsList.asObservable();
     constructor(private dataCoreService: DataCoreService,private _httpClient:HttpClient) {}


  setParams(birimKod: number, dosyaPlanKod: string,isReadOnly:boolean, isBindCheck:boolean){
    this.birimKod = birimKod;
    this.dosyaPlanKod = dosyaPlanKod;
    this.isReadOnly = isReadOnly;
    this.isBindCheck = isBindCheck;
  }
  
  getData(code: number,control:any, baseEntity?: string, isSetData?: boolean) {
     let dataSource: any;
     let tableName = "";
    const filterArr = [];
      if (this.isBindCheck && this.isReadOnly){
      tableName = control.showEntity?control.showEntity:control.dlistMetadata.baseEntity;
      dataSource = this.dataCoreService.getOData(tableName);
    dataSource.select([]);
    } 
    else{
      dataSource = this.dataCoreService.getOData(baseEntity);
    dataSource.select([]);
    if (this.birimKod) filterArr.push(['BirimKod', '=', this.birimKod]);
    if (this.dosyaPlanKod) filterArr.push(['DosyaPlanKod', '=', this.dosyaPlanKod]);
    }
    if (code) filterArr.push(['BelgeTuruKod', '=', code]);
    if (filterArr.length > 0) dataSource.filter(filterArr);
    return dataSource;
  }
}
